import PropTypes from 'prop-types';
import React, { useRef, useEffect } from 'react';
import classnames from 'classnames';
import _ from 'lodash';

import { BAlertTypes } from '../../constants/AppConstants';
import scrollComponentIntoView from '../../helpers/scrollComponentIntoView';

import Icon from './Icon';

function BAlert ({ type, children, onClose, className, focusOnload, ...otherProps }) {

    const alertRef = useRef(null);

    useEffect( () => {
        if (focusOnload) {
            alertRef.current.focus();
        }
    }, [focusOnload, alertRef]);

    const dismissible = onClose !== _.noop;
    const classNames = classnames('b-alert', className, {
        'b-alert--success': type === BAlertTypes.SUCCESS,
        'b-alert--info': type === BAlertTypes.INFO,
        'b-alert--warning': type === BAlertTypes.WARNING,
        'b-alert--danger': type === BAlertTypes.DANGER,
        'b-alert--dismissible': dismissible
    });
    return (
        <div tabIndex="0" ref={alertRef} className={ classNames } { ...otherProps }>
            { dismissible && <Icon icon="clear" className="b-alert__close" onClick={ onClose }/> }
            { children }
        </div>
    );
}

BAlert.propTypes = {
    className: PropTypes.string,
    type: PropTypes.oneOf(_.values(BAlertTypes)).isRequired,
    onClose: PropTypes.func,
    children: PropTypes.node,
    focusOnload: PropTypes.bool,
};

BAlert.defaultProps = {
    className: '',
    onClose: _.noop,
    children: null
};

export default BAlert;
export const bAlertType = BAlertTypes;
export const VisibleBAlert = scrollComponentIntoView(BAlert);

